import { apiFetch } from '@/util/apiClient';
import { getErrorMessage } from '@/util/errorUtils';
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function PasswordResetConfirm() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const { mutate, status } = useMutation({
    mutationFn: async () => {
      await apiFetch('/auth/password-reset-confirm/', {
        method: 'POST',
        body: JSON.stringify({ code, password }),
      });
    },
    onSuccess: () => navigate('/login'),
    onError: (err: unknown) => setError(getErrorMessage(err)),
  });

  return (
    <Container maxWidth={'xs'}>
      <Paper
        elevation={6}
        sx={{ p: 4, mt: 8, display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <Typography variant={'h4'} gutterBottom>
          Choose New Password
        </Typography>
        {error && <Alert severity={'error'}>{error}</Alert>}
        <Box
          component={'form'}
          onSubmit={(e) => {
            e.preventDefault();
            mutate();
          }}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <TextField
            label={'New Password'}
            type={'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button type={'submit'} variant={'contained'}>
            Set Password
          </Button>
          {status === 'pending' && <p>Saving...</p>}
        </Box>
      </Paper>
    </Container>
  );
}
